class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.priceWrap = this.querySelector('[data-product-price]');
    this.availabilityWrap = this.querySelector('[data-product-availability]');
    this.addToCartBtn = this.querySelector('[data-add-to-cart]');
    this.skuWrap = this.querySelector('[data-product-sku]');
    this.dynamicCheckout = this.querySelector('[data-dynamic-checkout]');
    this.media = document.querySelector('product-media');
    this.productUrl = this.dataset.productUrl;

    this.stickyBar = document.querySelector('[data-sticky-bar]');
    this.stickyBarPrice = document.querySelector('[data-sticky-bar-price]');
    this.stickyBarSubmit = document.querySelector('[data-sticky-bar-submit]');

    if (!this.form) return;

    this.addEventListener('variant:change', (e) => this._onVariantChange(e.detail.variant));
    this.form.addEventListener('submit', (e) => this._onSubmit(e));

    this._initStickyBar();
  }

  _initStickyBar() {
    if (!this.stickyBar || !this.addToCartBtn) return;

    if (this.stickyBarSubmit) {
      this.stickyBarSubmit.addEventListener('click', () => {
        if (this.addToCartBtn.disabled) return;
        this.addToCartBtn.click();
      });
    }

    if (!('IntersectionObserver' in window)) return;
    this._observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        this.stickyBar.hidden = entry.isIntersecting;
      },
      { threshold: 0 }
    );
    this._observer.observe(this.addToCartBtn);
  }

  disconnectedCallback() {
    if (this._observer) this._observer.disconnect();
  }

  async _onVariantChange(variant) {
    if (!variant) {
      if (this.addToCartBtn) {
        this.addToCartBtn.disabled = true;
        this.addToCartBtn.textContent = window.ShirtWerkStrings.unavailable;
      }
      if (this.stickyBarSubmit) this.stickyBarSubmit.disabled = true;
      window.ShirtWerk.announce('A11yStatus', window.ShirtWerkStrings.unavailable);
      return;
    }

    // Das <select name="id"> im Variant-Picker trägt bereits den korrekten
    // Wert (component-variant-picker.js hält es bei jeder Auswahl synchron)
    // — kein separates verstecktes Feld nötig, siehe main-product.liquid.
    if (this.productUrl && window.history) {
      window.history.replaceState({}, '', `${this.productUrl}?variant=${variant.id}`);
    }

    const mediaId = (variant.featured_media && variant.featured_media.id) || (variant.featured_image && variant.featured_image.id);
    if (mediaId && this.media) this.media.showMedia(String(mediaId));

    try {
      const response = await fetch(`${this.productUrl}?variant=${variant.id}&section_id=main-product`);
      if (response.ok) {
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        this._swap(doc, '[data-product-price]', this.priceWrap);
        this._swap(doc, '[data-product-sku]', this.skuWrap);
        this._swap(doc, '[data-dynamic-checkout]', this.dynamicCheckout);
        this._swap(doc, '[data-product-price]', this.stickyBarPrice);
      }
    } catch (err) {
      /* Preis bleibt beim letzten bekannten Stand, kein harter Fehler nötig. */
    }

    if (this.availabilityWrap) {
      this.availabilityWrap.innerHTML = variant.available
        ? `<span class="main-product__in-stock">${window.ShirtWerkStrings.inStock}</span>`
        : `<span class="main-product__sold-out">${window.ShirtWerkStrings.soldOut}</span>`;
    }
    if (this.addToCartBtn) {
      this.addToCartBtn.disabled = !variant.available;
      this.addToCartBtn.textContent = variant.available ? window.ShirtWerkStrings.addToCart : window.ShirtWerkStrings.soldOut;
    }
    if (this.stickyBarSubmit) {
      this.stickyBarSubmit.disabled = !variant.available;
      this.stickyBarSubmit.textContent = variant.available ? window.ShirtWerkStrings.addToCart : window.ShirtWerkStrings.soldOut;
    }
    window.ShirtWerk.announce('A11yStatus', `${variant.title} — ${variant.available ? window.ShirtWerkStrings.inStock : window.ShirtWerkStrings.soldOut}`);
  }

  _swap(doc, selector, target) {
    if (!target) return;
    const fresh = doc.querySelector(selector);
    if (fresh) target.innerHTML = fresh.innerHTML;
  }

  _onSubmit(e) {
    e.preventDefault();
    if (this.addToCartBtn) {
      this.addToCartBtn.disabled = true;
      this.addToCartBtn.classList.add('is-loading');
    }

    const formData = new FormData(this.form);
    const payload = {};
    formData.forEach((value, key) => {
      payload[key] = value;
    });

    const resetButton = () => {
      if (this.addToCartBtn) {
        this.addToCartBtn.disabled = false;
        this.addToCartBtn.classList.remove('is-loading');
      }
    };

    document.addEventListener('cart:updated', resetButton, { once: true });
    document.addEventListener('cart:error', (err) => {
      resetButton();
      window.ShirtWerk.announce('A11yStatus', (err.detail && err.detail.message) || window.ShirtWerkStrings.error);
    }, { once: true });

    document.dispatchEvent(new CustomEvent('cart:add', { detail: { formData: payload, trigger: this.addToCartBtn } }));
  }
}
customElements.define('product-form', ProductForm);
